export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";
export const PAGENO = "PAGENO";
export const ALL_PAGES_NO = "ALL_PAGES_NO" 
export const MOBILE_IMAGE_COUNT = "MOBILE_IMAGE_COUNT";
export const DESKTOP_IMAGE_COUNT = "DESKTOP_IMAGE_COUNT";

export const handleIncrement=()=> {
  return { type: INCREMENT }
}

export const handleDecrement=()=> {
    return { type: DECREMENT }
}

export const handlePageNumber=(pageNumber)=> {
  console.log("from action",pageNumber)
  return {
    type: PAGENO,
    payload: pageNumber
  }
}

export const allPagesNumbers=(allPagesNo)=> {
  console.log(allPagesNo);
  return {
    type: ALL_PAGES_NO,
    payload: allPagesNo
  }
}


export const handleMobileImageCount=(mob_images)=> {
  console.log("MOB IAMGES TOTAL: ",mob_images);
  return {
    type: MOBILE_IMAGE_COUNT,
    payload: mob_images
  }
}

export const handleDesktopImageCount=(desk_images)=> {
  console.log("DESK IAMGES TOTAL: ",desk_images);
  return {
    type: DESKTOP_IMAGE_COUNT,
    payload: desk_images
  }
}
 